<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData ? (userData.userLoginIp ? userData.userLoginId+'('+userData.userLoginIp+')' : userData.userLoginId) : '' }}
            </p>
            <span class="user-status">{{ userData ? userData.role : '' }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/1-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MailIcon"
            class="mr-50"
          />
          <span>Inbox</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="CheckSquareIcon"
            class="mr-50"
          />
          <span>Task</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MessageSquareIcon"
            class="mr-50"
          />
          <span>Chat</span>
        </b-dropdown-item> -->

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click.prevent="logout()"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="isQaRole"
          link-class="d-flex align-items-center"
          @click.prevent="move('apps-qa-tools')"
        >
          <feather-icon
            size="16"
            icon="ToolIcon"
            class="mr-50"
          />
          <span>QA 도구</span>
        </b-dropdown-item>

      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import axios from '@axios'
import { ref, onMounted, getCurrentInstance } from '@vue/composition-api'
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { getUserData, clearUserData } from '@/auth/utils'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,
  },

  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

  setup() {
    onMounted(() => {
      checkQA()
    })

    const instance = getCurrentInstance()
    const router = instance.proxy.$router
    const userData = getUserData()
    const isClient = (userData && userData.role === 'Client')
    const isQaRole = ref(false)

    const logout = () => {
      if (isClient) {
        axios.post('/cl/client/logout')
          .then(() => {
            clearUserData()

            router.push({ name: 'client-login' }) // 제약사 Role일시 제약사 로그인페이지로 이동
          })
      } else {
        axios.post('/fa/auth/logout')
          .then(() => {
            clearUserData()

            router.push({ name: 'auth-login' })
          })
      }
    }

    const move = routeName => {
      router.push({ name: routeName }) // routeName 페이지로 이동
    }

    const checkQA = () => {
      if (userData.horizontalRoles?.includes(11)) {
        isQaRole.value = true // QA_Tools_Use(11) 권한이 있을때만 true
      } else {
        isQaRole.value = false // 기본값
      }
    }

    return {
      userData,
      logout,
      move,
      isQaRole,
    }
  },
}
</script>
